module.exports = __webpack_public_path__ + "static/media/attendance.bf8fdde3.wav";